import axios from 'axios';

/**
 * Verifica se o erro da requisição é um 404
 * @param error erro da requisição
 */
export function isNotFoundError(error: unknown): boolean {
  return axios.isAxiosError(error) && error.response?.status === 404;
}
